/**
 * @module Countdown
 */
import Countdown from './libs/Countdown';

(function CountdownHandler() {
    function countDownHandler(element) {

        /**
         * HTML Element of countdown
         */
        const countdownDOM = element;

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {

            const countDownTimer = countdownDOM.querySelector('.countdown__timer');
            const countDownProgress = countdownDOM.querySelector('.countdown__progress-bar');

            let endDate = new Date();
            // missing milliseconds from php, so add factor 1000
            endDate.setTime(countDownTimer.dataset.countdownEnd * 1000);

            let startDate = new Date();
            // missing milliseconds from php, so add factor 1000
            startDate.setTime(countDownTimer.dataset.countdownStart * 1000);

            let cd = new Countdown({
                cont: countDownTimer,
                endDate: endDate.getTime(),
                outputTranslation: {
                    day: countDownTimer.dataset.countdownLabelDays,
                    hour: countDownTimer.dataset.countdownLabelHours,
                    minute: countDownTimer.dataset.countdownLabelMinutes,
                    second: countDownTimer.dataset.countdownLabelSeconds,
                },
                endCallback: null,
                outputFormat: countDownTimer.dataset.countdownUnits,
                progressbar: countDownProgress,
                startTimestamp: startDate.getTime(),
                endTimestamp: endDate.getTime()
            });
            cd.start();
        };

        /**
         * initialize call
         */
        this.init();
    }

    // define the global scope
    if (!window.Juzo) {
        window.Juzo = {};
    }
    window.Juzo.countDownHandler = countDownHandler;
})();
$(document).ready(function () {
    const countdowns = document.querySelectorAll('.countdown__wrapper');
    for (let singleCountdown of countdowns) {
        window.Juzo.countDownHandler(singleCountdown);
    }
});
